/* global easeOutQuint:false */



/**
 * Non-jQuery version on animated scrolling
 *
 * Inspired by https://stackoverflow.com/questions/8917921/cross-browser-javascript-not-jquery-scroll-to-top-animation
 */

function verticalScrollTo(element, to, speed, easing) {
	// speed: time in pixels per second
	// easing: easing equation to use

	speed = speed || 1000;
	easing = easing || easeOutQuint;

	var from = element.scrollTop;
	var currentTime = 0;

	// min time .1, max time .8 seconds
	var time = Math.max(.1, Math.min(Math.abs(from - to) / speed, .8));

	// add animation loop
	function tick() {
		currentTime += 1 / 60;

		var p = currentTime / time;
		var t = easing(p);

		if (p < 1) {
			window.requestAnimFrame(tick);
			element.scrollTop = from + ((to - from) * t);
		} else {
			element.scrollTop = to;
		}
	}

	// call it once to get started
	tick();
}



function horizontalScrollTo(element, to, speed, easing) {
	// speed: time in pixels per second
	// easing: easing equation to use

	speed = speed || 1000;
	easing = easing || easeOutQuint;

	var from = element.scrollLeft;
	var currentTime = 0;

	// min time .1, max time .8 seconds
	var time = Math.max(.1, Math.min(Math.abs(from - to) / speed, .8));

	// add animation loop
	function tick() {
		currentTime += 1 / 60;

		var p = currentTime / time;
		var t = easing(p);

		if (p < 1) {
			window.requestAnimFrame(tick);
			element.scrollLeft = from + ((to - from) * t);
		} else {
			element.scrollLeft = to;
		}
	}

	// call it once to get started
	tick();
}



/**
 * Animated scrolling effect to specific anchor on the page marked by #hash
 */

const scrollToLink = document.querySelector('.js-scroll-to-link');
if (scrollToLink) {
	scrollToLink.addEventListener('click', function(e) {
		e.preventDefault();

		if (this.hash && this.hash.length > 0 && (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') || location.hostname === this.hostname)) {
			var hash = decodeURI(this.hash),
				target = document.querySelector(hash),
				element = this,
				position = 0;

			console.log(target, hash);

			if (hash.slice(1).length > 0) {
				target = target || document.querySelector('[name=' + hash.slice(1) +']');
				if (target !== null) {
					position = target.offsetTop;
				}
			}

			if (position > 0) {
				var offset = element.getAttribute('data-scroll-offset') || 20;

				var updateAnchor = element.getAttribute('data-update-anchor');
				if (updateAnchor && updateAnchor === 'true') {
					if (target.length) {
						target.getAttribute('id', '');
					}

					window.location.hash = hash;

					if (target.length) {
						target.getAttribute('id', hash.slice(1));
					}
				}

				verticalScrollTo(document.querySelector('html,body'), position - offset, 500);

				return false;
			}
		}
	});
}
